import React from 'react';
import { Table } from 'react-bootstrap';
import { useLanguage } from '../context/LanguageContext';

interface KPI {
  id: number;
  engagementCode: string;
  auditClientCode: string;
  companyName: string;
  auditMgr: string;
  auditInCharge: string;
  invoice: number;
  cost: number;
  recoverability: string;
}

const KPI: React.FC = () => {
  // Sample data for the KPI list - using hard-coded engagement codes
  const kpis: KPI[] = [
    {
      id: 1,
      engagementCode: 'AUD20260001',
      auditClientCode: 'AC001',
      companyName: 'ABC Company Limited',
      auditMgr: 'Nicole Lai',
      auditInCharge: 'Harry Yip',
      invoice: 5000,
      cost: 4000,
      recoverability: ''
    },
    {
      id: 2,
      engagementCode: 'AUD20260002',
      auditClientCode: 'AC002',
      companyName: 'XYZ Corporation',
      auditMgr: 'Nicole Lai',
      auditInCharge: 'Harry Yip',
      invoice: 7500,
      cost: 6000,
      recoverability: ''
    },
    {
      id: 3,
      engagementCode: 'AUD20260003',
      auditClientCode: 'AC003',
      companyName: 'DEF Industries',
      auditMgr: 'Nicole Lai',
      auditInCharge: 'Harry Yip',
      invoice: 10000,
      cost: 8000,
      recoverability: ''
    }
  ];

  // Calculate recoverability for each KPI: (Invoice - Cost) / Invoice as percentage
  const kpisWithRecoverability = kpis.map(kpi => {
    const recoverability = kpi.invoice !== 0 ? ((kpi.invoice - kpi.cost) / kpi.invoice) * 100 : 0;
    return {
      ...kpi,
      recoverability: recoverability.toFixed(2) + '%'
    };
  });

  const { t } = useLanguage();

  return (
    <div className="kpi">
      <h2>{t('kpi')}</h2>

      {/* KPI Table */}
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>
              <div>#</div>
              <div className="text-muted small">(編號)</div>
            </th>
            <th>
              <div>{t('engagement')}</div>
              <div className="text-muted small">(項目代碼)</div>
            </th>
            <th>
              <div>{t('auditClientCode')}</div>
              <div className="text-muted small">(審計客戶代碼)</div>
            </th>
            <th>
              <div>{t('companyName')}</div>
              <div className="text-muted small">(公司名稱)</div>
            </th>
            <th>
              <div>Audit Mgr</div>
              <div className="text-muted small">(審計經理)</div>
            </th>
            <th>
              <div>Audit in-charge</div>
              <div className="text-muted small">(審計負責人)</div>
            </th>
            <th>
              <div>{t('invoice')}</div>
              <div className="text-muted small">(發票)</div>
            </th>
            <th>
              <div>Cost</div>
              <div className="text-muted small">(成本)</div>
            </th>
            <th>
              <div>Recoverability</div>
              <div className="text-muted small">(回收率)</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {kpisWithRecoverability.map((kpi) => (
            <tr key={kpi.id}>
              <td>{kpi.id}</td>
              <td>{kpi.engagementCode}</td>
              <td>{kpi.auditClientCode}</td>
              <td>{kpi.companyName}</td>
              <td>{kpi.auditMgr}</td>
              <td>{kpi.auditInCharge}</td>
              <td>${kpi.invoice.toLocaleString()}</td>
              <td>${kpi.cost.toLocaleString()}</td>
              <td>{kpi.recoverability}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default KPI;